export const TEAM_CREATE_SUC = 'sport.teamCreate.success';
export const teamCreateSucceess = (team, sportId, uuid) => ({
  type: TEAM_CREATE_SUC,
  team,
  sportId,
  uuid,
});
